import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-1294" data-mp="2lsl8nubanf6i">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-1295" data-mp="2lqgtuhbuwvrg">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-7" data-id="element-1296" data-mp="30iipfp6w92lo">
          <div className="mb-6" data-id="element-1297" data-mp="3jeqzd6auq1nb">
            <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em]" data-id="element-1298" data-mp="3jdplku2gb11w">
              Why This Matters
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-ink-dark leading-tight mb-8 text-balance" data-id="element-1299" data-mp="1p2u0wtdzrvir">
            Modern societies demand judgment, but rarely build it.
          </h2>

          <div className="space-y-6 text-lg text-ink-muted leading-relaxed" data-id="element-1300" data-mp="jeoiwfu2nyqc">
            <p data-id="element-1301" data-mp="od9hkatoeaco">
              People are expected to evaluate information, resist manipulation,
              regulate emotion under stress, plan for the future, cooperate
              across differences, and choose leaders capable of governing
              complexity.
            </p>
            <p data-id="element-1302" data-mp="124e9srups0cz">
              Most systems still focus on credentials, short-term outputs, and
              reactive crisis management instead of deliberately developing
              judgment, resilience, and responsibility.
            </p>
            <p className="font-medium text-navy text-xl pt-4 border-t border-line mt-8" data-id="element-1303" data-mp="1c2kf7jfqboml">
              The Human Capability Framework was built to address that gap.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="lg:col-span-5 relative h-full min-h-[300px] flex items-center justify-center" data-id="element-1304" data-mp="3dvib5o4syxbr">
          <svg viewBox="0 0 300 300" className="w-full h-full max-w-sm" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1305" data-mp="ty254eglxsc6">
            <defs data-id="element-1306" data-mp="12z8oqwejzj9n">
              <pattern id="grid" width="30" height="30" patternUnits="userSpaceOnUse" data-id="element-1307" data-mp="12zrwjkahor9y">
                <path d="M 30 0 L 0 0 0 30" fill="none" stroke="#D9E2EC" strokeWidth="0.5" data-id="element-1308" data-mp="1cqwb4iw96a49" />
              </pattern>
            </defs>
            <rect width="300" height="300" fill="url(#grid)" data-id="element-1309" data-mp="1ls4a736lfeze" />

            {/* Abstract representation of complexity/noise vs clarity */}
            <g className="opacity-70" data-id="element-1310" data-mp="2abeafe5u0h3t">
              {/* Noise/Overload */}
              <circle cx="80" cy="80" r="40" stroke="#5B6675" strokeWidth="1" strokeDasharray="2 2" data-id="element-1311" data-mp="2a9bnj2zz743b" />
              <circle cx="100" cy="120" r="30" stroke="#5B6675" strokeWidth="1" data-id="element-1312" data-mp="20f2zoslw3zbh" />
              <circle cx="60" cy="140" r="25" stroke="#5B6675" strokeWidth="1" strokeDasharray="1 3" data-id="element-1313" data-mp="1rduz23vwime8" />
              <path d="M40 80 L120 140 M60 140 L100 80" stroke="#5B6675" strokeWidth="0.5" data-id="element-1314" data-mp="1hknzx0rr82ml" />

              {/* Filter/Structure */}
              <path d="M150 50 L150 250" stroke="#245B8F" strokeWidth="2" strokeDasharray="4 4" data-id="element-1315" data-mp="18o55tl7se8of" />

              {/* Clarity/Alignment */}
              <rect x="190" y="100" width="60" height="60" rx="4" fill="#FFFFFF" stroke="#123B5D" strokeWidth="1.5" data-id="element-1316" data-mp="qvjp45115yqf" />
              <circle cx="220" cy="130" r="8" fill="#2E8C88" data-id="element-1317" data-mp="hwg4uxq4ndac" />
              <path d="M220 100 L220 160 M190 130 L250 130" stroke="#D9E2EC" strokeWidth="1" data-id="element-1318" data-mp="cv8vwvc90823" />
            </g>
          </svg>
        </motion.div>
      </div>
    </section>;
}